module.exports = __webpack_public_path__ + "img/nowin.a82d306b.png";